// extracted by mini-css-extract-plugin
export var active = "_e0-2";
export var recordingDot = "_e0-1";
export var recordingIndicator = "_e0-0";